import type { Plugin } from 'vue'
import { createApp, ref } from 'vue'
import MessageContainer from './MessageContainer.vue'

const noop: Plugin = () => {
  // do nothing
}

const plugin = ((): Plugin => {
  if (import.meta.env.MODE !== 'development') {
    return noop
  }

  // eslint-disable-next-line fp/no-let
  let called = false

  return app => {
    if (called) {
      console.warn('errorNotifierPlugin has been already installed')
      return
    }

    called = true

    const vueContainer = document.createElement('div')
    const component = document.body.appendChild(vueContainer)

    const errors = ref<string[]>([])

    const cApp = createApp(MessageContainer, {
      errors,
      click(index: number) {
        errors.value = errors.value.filter((_, i) => i !== index)
      },
    })
    cApp.mount(component)

    app.config.errorHandler = (...args) => {
      errors.value = [...errors.value, `Error: ${args[0]}`]

      console.error(...args)
    }

    app.config.warnHandler = (...args) => {
      errors.value = [...errors.value, `Warn: ${args[0]}`]

      console.warn(...args)
    }

    window.addEventListener('error', event => {
      errors.value = [...errors.value, `Error: ${event.error}`]

      console.error(event)
    })

    window.addEventListener('unhandledrejection', event => {
      errors.value = [...errors.value, `Unhandledrejection: ${event.reason}`]

      console.error(event)
    })
  }
})()

export default plugin
